import { Component, input } from '@angular/core';

@Component({
  selector: 'app-error-panel',
  templateUrl: './error-panel.component.html',
  styleUrls: ['./error-panel.component.scss'],
  standalone: false,
})
export class ErrorPanelComponent {
  /* Collection of error message keys to be displayed */
  errorPayload = input<string[]>([]);

  /* Controls visibility of the problem headline */
  showProblem = input<boolean>(false);

  get uniqueErrors() {
    return new Set(this.errorPayload());
  }

}
